/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type PresidentialDocumentTypeItem = typeof PresidentialDocumentTypeItem[keyof typeof PresidentialDocumentTypeItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PresidentialDocumentTypeItem = {
  determination: 'determination',
  executive_order: 'executive_order',
  memorandum: 'memorandum',
  notice: 'notice',
  proclamation: 'proclamation',
  presidential_order: 'presidential_order',
  other: 'other',
} as const;
